import React, { useEffect, useContext } from 'react';
import { Routes, Route, Navigate, redirect, useLocation  } from "react-router-dom";

/** Component Pages Here */
import HomePage from '../components/pages/HomePage';
import StoreSelector from '../components/pages/StoreSelector';
import FormContext from '../services/formContext';

/**
 * Store Profile
 */
import StoreProfilePage from '../components/pages/store/StoreProfilePage';
import StoreDeliveryAddressPage from '../components/pages/store/StoreDeliveryAddressPage';
import StoreWarehousesPage from '../components/pages/store/StoreWarehousesPage';

import LoginPage from '../components/pages/LoginPage';
import Page404 from '../components/pages/Page404';
import DeniedPage from '../components/pages/DeniedPage';

import StarterTemplate from '../components/pages/StarterTemplate';

import ProfilePage from '../components/pages/account/ProfilePage';

import ProductList from '../components/pages/products/ProductList';
import ProductForm from '../components/pages/products/ProductForm';

import InventoryAdjustmentList from '../components/pages/products/InventoryAdjustmentList';
import InventoryAdjustmentForm from '../components/pages/products/InventoryAdjustmentForm';

import SalesOrderList from '../components/pages/sales-order/SalesOrderList';
//import SalesOrderForm from '../components/pages/sales-order/SalesOrderForm';
import SalesOrderView from '../components/pages/sales-order/SalesOrderView';
import SalesOrderForm from '../components/pages/sales-order/SalesOrderForm';
import SalesOrderPrintView from '../components/pages/sales-order/SalesOrderPrintView';

import SalesReturnList from '../components/pages/sales-order/SalesReturnList';
import SalesReturnForm from '../components/pages/sales-order/SalesReturnForm';

import InvoicesList from '../components/pages/invoices/InvoicesList';
import InvoiceForm from '../components/pages/invoices/InvoiceForm';
import InvoiceView from '../components/pages/invoices/InvoiceView';
import InvoicePrintView from '../components/pages/invoices/InvoicePrintView';

import PaymentReceiveList from '../components/pages/payment-received/PaymentReceiveList';
import PaymentReceiveForm from '../components/pages/payment-received/PaymentReceiveForm';

import PurchaseOrderList from '../components/pages/purchase-order/PurchaseOrderList';
import PurchaseOrderFormV1 from '../components/pages/purchase-order/PurchaseOrderFormBAK';
import PurchaseOrderForm from '../components/pages/purchase-order/PurchaseOrderForm';
import PurchaseOrderPrintView from '../components/pages/purchase-order/PurchaseOrderPrintView';
import PurchaseOrderView from '../components/pages/purchase-order/PurchaseOrderView';

import PurchaseReceivesList from '../components/pages/purchase-order/PurchaseReceivesList';
import PurchaseReceiveForm from '../components/pages/purchase-order/PurchaseReceiveForm';

import BillsList from '../components/pages/bills/BillsList';
import BillForm from '../components/pages/bills/BillForm';
import BillView from '../components/pages/bills/BillView';
import BillPrintView from '../components/pages/bills/BillPrintView';

import PaymentMadeList from '../components/pages/payment-made/PaymentMadeList';
import PaymentMadeForm from '../components/pages/payment-made/PaymentMadeForm';

import BrandsList from '../components/pages/management/BrandsList';
import VariantTypesList from '../components/pages/products/VariantTypesList';
import CategoryList from '../components/pages/management/CategoryList';

import ShipmentsList from '../components/pages/sales-order/ShipmentList';
import ShipmentForm from '../components/pages/sales-order/ShipmentForm';

import ContactList from '../components/pages/management/ContactList';
import ContactForm from '../components/pages/management/ContactForm';

import VendorsList from '../components/pages/management/VendorsList';
import VendorsForm from '../components/pages/management/VendorsForm';

import CouriersList from '../components/pages/management/CouriersList';

import helpers from '../services/helpers';
import Swal from 'sweetalert2';

/**
 * Reports
 */
import ReportListPage from '../components/pages/reports/ReportListPage';
import ReportInventory from '../components/pages/reports/ReportInventory';
import ReportSalesOrder from '../components/pages/reports/ReportSalesOrder';
import ReportSalesItem from '../components/pages/reports/ReportSalesItem';
import ReportInvoices from '../components/pages/reports/ReportInvoices';
import ReportPurchasesOrder from '../components/pages/reports/ReportPurchasesOrder';
import ReportPurchasesItem from '../components/pages/reports/ReportPurchasesItem';
import ReportBills from '../components/pages/reports/ReportBills';
import ReportContacts from '../components/pages/reports/ReportContacts';
import ReportVendors from '../components/pages/reports/ReportVendors';
import ReportPaymentReceived from '../components/pages/reports/ReportPaymentReceived';
import ReportPaymentMade from '../components/pages/reports/ReportPaymentMade';
import ReportSalesReturn from '../components/pages/reports/ReportSalesReturn';
/************************ */

/**
 * Settings
 */
import PageSettings from '../components/pages/management/PageSettings';
import TaxRatesList from '../components/pages/management/TaxRatesList';
import DiscountRatesList from '../components/pages/discount-rates/DiscountRatesList';

import UnderConstructionPage from '../components/pages/UnderConstructionPage';

/**
 * Accounting Module
 */
import ChartOfAccountsList from '../components/pages/accounting/ChartOfAccountsList';
import JournalsList from '../components/pages/accounting/JournalsList';
import SharesList from '../components/app/savers/SharesList';
import HomePageSavers from '../components/app/savers/HomePageSavers';
import SharesForm from '../components/app/savers/SharesForm';
import GroupForm from '../components/app/savers/GroupForm';
import ProductUnitList from '../components/pages/service-hub/ProductUnitList';
import ProductUnitForm from '../components/pages/service-hub/ProductUnitForm';
import ServiceRequestList from '../components/pages/service-hub/ServiceRequestList';
import ServiceRequestForm from '../components/pages/service-hub/ServiceRequestForm';
import ServiceRequestView from '../components/pages/service-hub/ServiceRequestView';
import ServiceRequestSchedule from '../components/pages/service-hub/ServiceRequestSchedule';
import ServiceRequestAssessment from '../components/pages/service-hub/ServiceRequestAssessment';
import ServiceRequestAcceptance from '../components/pages/service-hub/ServiceRequestAcceptance';
import ServiceRequestPrintView from '../components/pages/service-hub/ServiceRequestPrintView';
import ReportServiceHub from '../components/pages/service-hub/ReportServiceHub';
import ServiceRequestPrintAcceptanceView from '../components/pages/service-hub/ServiceRequestPrintAcceptanceView';
import ServiceRequestSOAPrintView from '../components/pages/service-hub/ServiceRequestSOAPrintView';
import CustomerMapDashboard from '../components/pages/dashboard/CustomerMapDashboard';
import PolarServDashboard from '../components/pages/dashboard/PolarServDashboard';
import EmployeesList from '../components/app/hr/EmployeesList';
import RolesList from '../components/pages/roles/RolesList';
import RolesForm from '../components/pages/roles/RolesForm';
import UsersList from '../components/pages/users/UsersList';
import UsersForm from '../components/pages/users/UsersForm';

const Protected = ({ isLoggedIn, requiredPermissions=[],  children, requestor='' }) => {
    const is_authenticated = helpers.isAuthenticated();
    const token = helpers.getToken();
    const authorized = helpers.requiredPermissions(requiredPermissions);
    const default_store = Object.keys(helpers.getDefaultStore()).length

    if(token === 'undefined' || !is_authenticated){
        return <Navigate replace to="/login" />
    }
    else if(!default_store){
        return <Navigate replace to="/my-store" />
    }
    else if(requiredPermissions.length && !authorized){
        //return <Navigate replace to="/" />
        return <DeniedPage />
    }
    
    return children;
};

function MainRoutes(){
    const {
        account
    } = useContext(FormContext);

    const location = useLocation();
    var interval = setInterval(() => {
        if(location.pathname != '/login' && location.pathname != '/'){
            // if(helpers.getToken() === 'undefined' || !helpers.isAuthenticated()){
            // clearInterval(interval);

            // Swal.fire({
            //     //title: 'Your session has change or expired',
            //     text: 'Your session has changed or expired. Please log in again to continue using the app.',
            //     showCancelButton: false,
            //     showConfirmButton: true,
            //     closeOnCancel: true,
            //     confirmButtonText: 'Log In',
            //     allowOutsideClick: false,
            //     icon: "error",
            //     })
            //     .then((result) => {
            //         if (result.isConfirmed) {
            //             window.location.href = "/login";
            //         }
            //     })
            // }
            // return;
        }
    }, 3000);

    const ProtectedRoute = ({ isLoggedIn, requiredPermissions=[],  children, requestor='' }) => {
        const is_authenticated = helpers.isAuthenticated();
        const token = helpers.getToken();
        const permissions = account.permissions ?? ['superAdmin']
        const authorized = helpers.checkPermissions(requiredPermissions, permissions);

        if(token === 'undefined' || !is_authenticated){
            return <Navigate replace to="/login" />
        }
        else if(requiredPermissions.length && !authorized){
            return <DeniedPage />
        }
        
        return children;
    };

    return (
        <>
        <Routes>
            <Route 
                exact path="/"
                element={
                    <ProtectedRoute>
                        <Navigate replace to="/dashboard" />
                    </ProtectedRoute>
                }
            />

            <Route 
                exact path="/login" 
                element={<LoginPage />} 
            />

            <Route 
                exact path="account/profile" 
                element={
                    <ProtectedRoute>
                        <ProfilePage />
                    </ProtectedRoute>
                }
            />

            {/* USERS */}
            <Route 
                exact path="account/users/manage" 
                element={
                    <ProtectedRoute requiredPermissions={["superAdmin", "userView", "userCreate", "userEdit", "userDelete"]}>
                        <UsersList />
                    </ProtectedRoute>
                }
            />

            <Route 
                exact path="account/users/new" 
                element={
                    <ProtectedRoute requiredPermissions={["superAdmin", "userCreate"]}>
                        <UsersForm />
                    </ProtectedRoute>
                }
            />

            <Route 
                exact path="account/users/:user_id/edit" 
                element={
                    <ProtectedRoute requiredPermissions={["superAdmin", "userEdit"]}>
                        <UsersForm />
                    </ProtectedRoute>
                }
            />

            {/* ROLES */}
            <Route 
                exact path="account/roles/manage" 
                element={
                    <ProtectedRoute requiredPermissions={["superAdmin", "roleView", "roleCreate", "roleEdit", "roleDelete"]}>
                        <RolesList />
                    </ProtectedRoute>
                }
            />

            <Route 
                exact path="account/roles/new" 
                element={
                    <ProtectedRoute requiredPermissions={["superAdmin", "roleCreate"]}>
                        <RolesForm />
                    </ProtectedRoute>
                }
            />

            <Route 
                exact path="account/roles/:role_id/edit" 
                element={
                    <ProtectedRoute requiredPermissions={["superAdmin", "roleEdit"]}>
                        <RolesForm />
                    </ProtectedRoute>
                }
            />

            

            {/* <Route path="/inventory"> */}
                    <Route 
                        exact path="dashboard"
                        element={
                            <ProtectedRoute>
                                <PolarServDashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route 
                        exact path="/customer-dashboard"
                        element={
                            <ProtectedRoute>
                                <CustomerMapDashboard />
                            </ProtectedRoute>
                        }
                    />

                    {/* STORE MANAGEMENT */}
                    <Route path="store">
                        <Route 
                            exact path="profile"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "storeAdmin","storeView","storeEdit"]}>
                                    <StoreProfilePage />
                                </ProtectedRoute>
                            }
                        />
                        <Route 
                            exact path="delivery-address"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "storeAdmin","storeView","storeEdit"]}>
                                    <StoreDeliveryAddressPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route 
                            exact path="warehouses"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "storeAdmin","storeView","storeEdit"]}>
                                    <StoreWarehousesPage />
                                </ProtectedRoute>
                            }
                        />
                        {/* <Route 
                            exact path="store"
                            element={
                                <ProtectedRoute>
                                    <UnderConstructionPage module="Store Management" />
                                </ProtectedRoute>
                            }
                        /> */}
                    </Route>
                    
                    {/* PRODUCTS */}
                    <Route 
                        exact path="item/list"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin", "inventoryView", "inventoryDelete"]}>
                                <ProductList />
                            </ProtectedRoute>
                        }
                    />
                    
                    <Route 
                        exact path="item/:product_id/edit"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin", "inventoryEdit"]}>
                                <ProductForm />
                            </ProtectedRoute>
                        }
                    />
                    
                    <Route 
                        exact path="item/form"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin", "inventoryCreate"]}>
                                <ProductForm />
                            </ProtectedRoute>
                        }
                    />
                        
                    <Route 
                        exact path="inventory-adjustment"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin", "inventoryAdjustView", "inventoryAdjustDelete"]}>
                                <InventoryAdjustmentList />
                            </ProtectedRoute>
                        }
                    />
                        
                    <Route 
                        exact path="inventory-adjustment/:adjustment_id/edit"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin", "inventoryAdjustEdit"]}>
                                <InventoryAdjustmentForm />
                            </ProtectedRoute>
                        }
                    />
                    
                    <Route 
                        exact path="inventory-adjustment/form"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin", "inventoryAdjustCreate"]}>
                                <InventoryAdjustmentForm />
                            </ProtectedRoute>
                        }
                    />
                    
                    <Route 
                        exact path="settings/brands"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin", "brandView", "brandCreate", "brandEdit", "brandDelete"]}>
                                <BrandsList />
                            </ProtectedRoute>
                        }
                    />
                
                    <Route 
                        exact path="settings/variant-types"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin", "variantTypeView", "variantTypeCreate", "variantTypeEdit", "variantTypeDelete"]}>
                                <VariantTypesList />
                            </ProtectedRoute>
                        }
                    />
                
                    <Route 
                        exact path="settings/categories"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin", "categoryView", "categoryCreate", "categoryEdit", "categoryDelete"]}>
                                <CategoryList />
                            </ProtectedRoute>
                        }
                    />

                    {/* SALES ORDER */}
                    {/* <Route path="sales"> */}
                        <Route 
                            exact path="sales/list"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "salesOrderView", "salesOrderCreate", "salesOrderEdit", "salesOrderDelete", "salesOrderCancel", "salesOrderReport"]}>
                                    <SalesOrderList />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="sales/form"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "salesOrderCreate"]}>
                                    <SalesOrderForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route  //View
                            exact path="sales/:order_id"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "salesOrderView"]}>
                                    <SalesOrderView />
                                </ProtectedRoute>
                            }
                        />

                        <Route // Print View
                            exact path="sales/:order_id/print"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "salesOrderView"]}>
                                    <SalesOrderPrintView />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="sales/:order_id/edit"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "salesOrderEdit"]}>
                                    <SalesOrderForm />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="sales/:order_id/sales-return"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "salesOrderView","salesReturnView","salesReturnCreate","salesReturnEdit"]}>
                                    <SalesReturnForm />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    {/* Invoices */}
                    {/* <Route path="invoices"> */}
                        <Route 
                            exact path="invoices/list"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "invoiceView","invoiceCreate","invoiceEdit","invoiceDelete","invoiceCancel"]}>
                                    <InvoicesList />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="invoices/form"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "invoiceCreate"]}>
                                    <InvoiceForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="invoices/:invoice_id/edit"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "invoiceEdit"]}>
                                    <InvoiceForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        {/* <Route 
                            exact path="invoices/:invoice_id/form"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "invoiceEdit"]}>
                                    <InvoiceForm />
                                </ProtectedRoute>
                            }
                        /> */}
                        
                        <Route 
                            exact path="invoices/:invoice_id/payment"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","paymentReceiveCreate","paymentReceiveEdit"]}>
                                    <PaymentReceiveForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route  //View
                            exact path="invoices/:invoice_id"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "invoiceView","invoiceCreate","invoiceDelete","invoiceCancel"]}>
                                    <InvoiceView />
                                </ProtectedRoute>
                            }
                        />

                        <Route // Print View
                            exact path="invoices/:invoice_id/print"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "invoiceView"]}>
                                    <InvoicePrintView />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    {/* Payment Receives */}
                    {/* <Route path="payment-receives"> */}
                        <Route 
                            exact path="payment-receives/list"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "paymentReceiveView","paymentReceiveCreate","paymentReceiveEdit","paymentReceiveDelete"]}>
                                    <PaymentReceiveList />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="payment-receives/form"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "paymentReceiveCreate"]}>
                                    <PaymentReceiveForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="payment-receives/:payment_receive_id/form"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "paymentReceiveEdit"]}>
                                    <PaymentReceiveForm />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    {/* Shipments */}
                    {/* <Route path="shipments"> */}
                        <Route 
                            exact path="shipments/list"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "shipmentView","shipmentCreate","shipmentEdit","shipmentDelete"]}>
                                    <ShipmentsList />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="shipments/:shipment_id/form"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "shipmentEdit"]}>
                                    <ShipmentForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="shipments/form"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "shipmentCreate"]}>
                                    <ShipmentForm />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    {/* Sales Returns */}
                    {/* <Route path="sales-returns"> */}
                        <Route 
                            exact path="sales-returns/list"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "salesReturnView","salesReturnCreate","salesReturnEdit","salesReturnDelete"]}>
                                    <SalesReturnList />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="sales-returns/:sales_return_id/form"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "salesReturnCreate","salesReturnEdit"]}>
                                    <SalesReturnForm />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    {/* Customers */}
                    {/* <Route path="customers"> */}
                        <Route 
                            exact path="customers/list"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "customerCreate","customerEdit", "customerDelete"]}>
                                    <ContactList />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="customers/:contact_id/edit"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","customerEdit"]}>
                                    <ContactForm />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="customers/:contact_id/product-units"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin"]}>
                                    <ProductUnitList home_page='contact' />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="customers/:contact_id/product-units/:product_unit_id/form"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin"]}>
                                    <ProductUnitForm />
                                </ProtectedRoute>
                            }
                        />
                    
                        <Route 
                            exact path="customers/form"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "customerCreate"]}>
                                    <ContactForm />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}
                    
                    {/* Couriers */}
                    <Route 
                        exact path="settings/couriers"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin", "courierCreate","courierEdit", "courierDelete"]}>
                                <CouriersList />
                            </ProtectedRoute>
                        }
                    />

                    {/* PURCHASE ORDER */}
                    {/* <Route path="purchases"> */}
                        <Route 
                            exact path="purchases/list"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "purchaseOrderView", "purchaseOrderCreate", "purchaseOrderEdit", "purchaseOrderDelete", "purchaseOrderCancel"]}>
                                    <PurchaseOrderList />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="purchases/form"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "purchaseOrderCreate"]}>
                                    <PurchaseOrderForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="purchases/:order_id"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "purchaseOrderView"]}>
                                    <PurchaseOrderView />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="purchases/:order_id/edit"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "purchaseOrderEdit"]}>
                                    <PurchaseOrderForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="purchases/:order_id/print"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "purchaseOrderView"]}>
                                    <PurchaseOrderPrintView />
                                </ProtectedRoute>
                            }
                        />
                        
                        {/* <Route 
                            exact path="purchases/form-v1"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "purchaseOrderCreate"]}>
                                    <PurchaseOrderFormV1 />
                                </ProtectedRoute>
                            }
                        /> */}
                    {/* </Route> */}
                    
                    {/* BILL */}
                    {/* <Route path="bills"> */}
                        <Route 
                            exact path="bills/list"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","billView","billCreate","billEdit","billDelete","billCancel"]}>
                                    <BillsList />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="bills/form"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","billCreate"]}>
                                    <BillForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="bills/:bill_id/edit"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","billEdit"]}>
                                    <BillForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="bills/:bill_id/form"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","billEdit"]}>
                                    <BillForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        {/* Payment made from bills */}
                        <Route 
                            exact path="bills/:bill_id/payment"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","paymentMadeCreate","paymentMadeEdit"]}>
                                    <PaymentMadeForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route  //View
                            exact path="bills/:bill_id"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","billView"]}>
                                    <BillView />
                                </ProtectedRoute>
                            }
                        />

                        <Route // Print View
                            exact path="bills/:bill_id/print"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","billView"]}>
                                    <BillPrintView />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    {/* PAYMENT MADE */}
                    {/* <Route path="payment-made"> */}
                        <Route 
                            exact path="payment-made/list"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","paymentMadeView","paymentMadeCreate","paymentMadeEdit","paymentMadeDelete"]}>
                                    <PaymentMadeList />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="payment-made/form"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","paymentMadeCreate"]}>
                                    <PaymentMadeForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="payment-made/:payment_made_id/form"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","paymentMadeEdit"]}>
                                    <PaymentMadeForm />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    
                    {/* PURCHASE RECEIVES */}
                    {/* <Route path="purchase-receives"> */}
                        <Route 
                            exact path="purchase-receives/list"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","purchaseReceiveView","purchaseReceiveCreate","purchaseReceiveEdit","purchaseReceiveDelete"]}>
                                    <PurchaseReceivesList />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="purchase-receives/:receive_id/edit"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","purchaseReceiveEdit"]}>
                                    <PurchaseReceiveForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="purchase-receives/form"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","purchaseReceiveCreate"]}>
                                    <PurchaseReceiveForm />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    {/* VENDORS */}
                    {/* <Route path="vendors"> */}
                        <Route 
                            exact path="vendors/list"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","vendorView","vendorCreate","vendorEdit","vendorDelete"]}>
                                    <VendorsList />
                                </ProtectedRoute>
                            }
                        />
                    
                        <Route 
                            exact path="vendors/form"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","vendorCreate"]}>
                                    <VendorsForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="vendors/:vendor_id/edit"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","vendorEdit"]}>
                                    <VendorsForm />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    {/* Reports */}
                    <Route 
                        exact path="reports"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin", "service-request-create"]}>
                                <ReportListPage />
                            </ProtectedRoute>
                        }
                    />
                    
                    <Route path="reports">
                        <Route 
                            exact path="item"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","inventoryReport"]}>
                                    <ReportInventory />
                                </ProtectedRoute>
                            }
                        />
                        <Route 
                            exact path="sales"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","salesOrderReport"]}>
                                    <ReportSalesOrder />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="sales/top-items"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","salesOrderReport"]}>
                                    <ReportSalesItem filtered_by='top-items' />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="sales/pending-deliveries"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","salesOrderReport"]}>
                                    <ReportSalesItem filtered_by='pending-delivery' />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="sales-return"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","salesOrderReport"]}>
                                    <ReportSalesReturn />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="invoices"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","invoiceReport"]}>
                                    <ReportInvoices />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="payments/received"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin","paymentReceiveReport"]}>
                                    <ReportPaymentReceived />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="bills"
                            element={
                                <ProtectedRoute  requiredPermissions={["superAdmin","billReport"]}>
                                    <ReportBills />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="payments/made"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "paymentMadeReport"]}>
                                    <ReportPaymentMade />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="purchases"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "purchaseOrderReport"]}>
                                    <ReportPurchasesOrder />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="purchases/top-items"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "purchaseOrderReport"]}>
                                    <ReportPurchasesItem filtered_by='top-items' />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="purchases/receivables"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "purchaseOrderReport"]}>
                                    <ReportPurchasesItem filtered_by='receivables' />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="customers"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "customerReport"]}>
                                    <ReportContacts />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="vendors"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "vendorReport"]}>
                                    <ReportVendors />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="service-requests"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "serviceHubReport"]}>
                                    <ReportServiceHub />
                                </ProtectedRoute>
                            }
                        />
                    
                    </Route>
                    {/* End of Reports */}

                    <Route 
                        exact path="settings" 
                        element={
                            <ProtectedRoute>
                                <PageSettings />
                            </ProtectedRoute>
                        }
                    />

                    <Route path="settings">
                        <Route 
                            exact path="tax-rates"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "taxRateView", "taxRateCreate", "taxRateEdit", "taxRateDelete"]}>
                                    <TaxRatesList />
                                </ProtectedRoute>
                            }
                        />
                    </Route>

                    <Route path="settings">
                        <Route 
                            exact path="discount-rates"
                            element={
                                <ProtectedRoute requiredPermissions={["superAdmin", "discountRateView", "discountRateCreate", "discountRateEdit", "discountRateDelete"]}>
                                    <DiscountRatesList />
                                </ProtectedRoute>
                            }
                        />
                    </Route>

                    {/* Accounting Module */}
                    {/* <Route 
                        exact path="chart-of-accounts"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin", "service-request-create"]}>
                                <ChartOfAccountsList />
                            </ProtectedRoute>
                        }
                    />
                    <Route 
                        exact path="journals"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin", "service-request-create"]}>
                                <JournalsList />
                            </ProtectedRoute>
                        }
                    /> */}
            {/* </Route> */}

            <Route 
                exact path="/app"
                element={
                    <ProtectedRoute>
                        <Navigate replace to="/dashboard" />
                    </ProtectedRoute>
                }
            />

            {/* ServiceHub */}
            <Route path="polarserv">
                <Route path="product-units">
                    <Route path="list"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin", "productUnitView","productUnitCreate","productUnitEdit","productUnitDelete"]}>
                                <ProductUnitList home_page='product-units' />
                            </ProtectedRoute>
                        }
                    />

                    <Route exact path="new"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin", "productUnitCreate"]}>
                                <ProductUnitForm />
                            </ProtectedRoute>
                        }
                    />

                    <Route exact path="qr/:qr_code"
                        element={
                            <ProductUnitForm />
                        }
                    />

                    <Route exact path=":product_unit_id/form"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin", "productUnitEdit"]}>
                                <ProductUnitForm />
                            </ProtectedRoute>
                        }
                    />
                </Route>

                {/* Service Request */}
                <Route path="service-requests/list"
                    element={
                        <ProtectedRoute requiredPermissions={["superAdmin", "serviceHubView","serviceHubCreate","serviceHubEdit","serviceHubDelete","serviceHubSchedule","serviceHubAssess","serviceHubAccept"]}>
                            <ServiceRequestList />
                        </ProtectedRoute>
                    }
                />

                <Route path="service-requests/schedule"
                    element={
                        <ProtectedRoute requiredPermissions={["superAdmin", "serviceHubSchedule"]}>
                            <ServiceRequestList view='assigned' menu="manage-service-schedule" page_title="Service Request Schedules" />
                        </ProtectedRoute>
                    }
                />

                <Route exact path="service-requests/schedule/:service_request_id"
                    element={
                        <ProtectedRoute requiredPermissions={["superAdmin", "serviceHubViewAssgined"]}>
                            <ServiceRequestView view='assigned' menu="manage-service-schedule" />
                        </ProtectedRoute>
                    }
                />

                <Route exact path="service-requests/new"
                    element={
                        <ProtectedRoute requiredPermissions={["superAdmin", "serviceHubCreate"]}>
                            <ServiceRequestForm />
                        </ProtectedRoute>
                    }
                />

                <Route path="service-requests/print-soa"
                    element={
                        <ProtectedRoute requiredPermissions={["superAdmin", "serviceHubView","serviceHubViewAssgined"]}>
                            <ServiceRequestSOAPrintView />
                        </ProtectedRoute>
                    }
                />

                <Route exact path="service-requests/:service_request_id/form"
                    element={
                        <ProtectedRoute requiredPermissions={["superAdmin", "serviceHubEdit"]}>
                            <ServiceRequestForm />
                        </ProtectedRoute>
                    }
                />

                <Route exact path="service-requests/:service_request_id/schedule"
                    element={
                        <ProtectedRoute requiredPermissions={["superAdmin", "serviceHubSchedule"]}>
                            <ServiceRequestSchedule />
                        </ProtectedRoute>
                    }
                />

                <Route exact path="service-requests/:service_request_id/acceptance"
                    element={
                        <ProtectedRoute requiredPermissions={["superAdmin", "serviceHubAccept"]}>
                            <ServiceRequestAcceptance />
                        </ProtectedRoute>
                    }
                />

                <Route exact path="service-requests/:service_request_id/assessment"
                    element={
                        <ProtectedRoute requiredPermissions={["superAdmin", "serviceHubAssess"]}>
                            <ServiceRequestAssessment />
                        </ProtectedRoute>
                    }
                />

                <Route exact path="service-requests/:service_request_id"
                    element={
                        <ProtectedRoute requiredPermissions={["superAdmin", "serviceHubView", "serviceHubViewAssgined"]}>
                            <ServiceRequestView />
                        </ProtectedRoute>
                    }
                />

                <Route exact path="service-requests/:service_request_id/print"
                    element={
                        <ProtectedRoute requiredPermissions={["superAdmin", "serviceHubView", "serviceHubViewAssgined"]}>
                            <ServiceRequestPrintView />
                        </ProtectedRoute>
                    }
                />

                <Route exact path="service-requests/:service_request_id/print-acceptance"
                    element={
                        <ProtectedRoute requiredPermissions={["superAdmin", "serviceHubView", "serviceHubViewAssgined"]}>
                            <ServiceRequestPrintAcceptanceView />
                        </ProtectedRoute>
                    }
                />
            </Route>

            {/* Human Resources Management System */}
            <Route path="hrms">
                <Route path="employees">
                    <Route 
                        exact path="list"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin", "employeeView", "employeeCreate", "employeeEdit", "employeeDelete"]}>
                                <EmployeesList />
                            </ProtectedRoute>
                        }
                    />
                </Route>
            </Route>
            
            {/* Apps Module */}
            <Route path="app/savers">
                <Route path=":group_id">
                    <Route 
                        exact path="dashboard"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin"]}>
                                <HomePageSavers />
                            </ProtectedRoute>
                        }
                    />
                    <Route 
                        exact path="info"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin"]}>
                                <GroupForm />
                            </ProtectedRoute>
                        }
                    />
                    <Route 
                        exact path="shares"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin"]}>
                                <SharesList />
                            </ProtectedRoute>
                        }
                    />
                    <Route 
                        exact path="shares/new"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin"]}>
                                <SharesForm />
                            </ProtectedRoute>
                        }
                    />
                    <Route 
                        exact path="shares/:share_id"
                        element={
                            <ProtectedRoute requiredPermissions={["superAdmin"]}>
                                <SharesForm />
                            </ProtectedRoute>
                        }
                    />
                </Route>

                <Route 
                    exact path="group/new"
                    element={
                        <ProtectedRoute requiredPermissions={["superAdmin"]}>
                            <SharesList />
                        </ProtectedRoute>
                    }
                />
            </Route>

            {/* Savers App */}
            <Route 
                exact path="/template"
                element={
                    <ProtectedRoute>
                        <StarterTemplate />
                    </ProtectedRoute>
                }
            />

            {/* 
            <Route 
                exact path="/production" 
                element={<UnderConstructionPage module="Production Management System" />} 
            />
            */}

            <Route 
                path="*" 
                element={<Page404 />} 
            />
        </Routes>
        </>
    )
}

export default MainRoutes;
